import {SMSWOUnifiedDashboardServiceLambda} from "@amzn/swo-unified-dashboard-service-lambda-js-client";
import {unifiedDashboardAPIConfig} from "src/utils/api-gateway/swo-ud-api-mappings";
import {getStage} from "src/utils/env";
import {
    programColumnMetadata,
    subProgramColumnMetadata,
    targetedWebsiteColumnMetadata, workflowStatusColumnMetadata
} from "src/components/domain-tracker/table-metadata";
import {EXECUTION_LIST_DROPDOWN_OPTIONS} from "src/constants/domain-tracker";

export class LoadFieldValues {

    private unifiedDashboardServiceLambda: SMSWOUnifiedDashboardServiceLambda;

    constructor() {
        const unifiedDashboardConfig = unifiedDashboardAPIConfig(getStage());
        this.unifiedDashboardServiceLambda = new SMSWOUnifiedDashboardServiceLambda({
            endpoint: `https://${unifiedDashboardConfig.endpoint}/${unifiedDashboardConfig.stage}`,
            region: unifiedDashboardConfig.region,
        });
    }

    async loadDistinctFieldValuesFromIndex(field: string, index: 'EVENTS_INDEX' | 'SWO_JOIN_DATA_INDEX') {
        let loadFieldValuesRequest = {
            field: field,
            index: index
        };
        return this.unifiedDashboardServiceLambda.loadFieldValues(loadFieldValuesRequest).promise();
    }

    static async getAttributeValuesByKey(searchKey: string): Promise<Array<string>> {
        if (DYNAMIC_DROPDOWN_FIELDS.includes(searchKey)) {
            const loadFieldValues = new LoadFieldValues();
            const result = await loadFieldValues.loadDistinctFieldValuesFromIndex(searchKey, 'EVENTS_INDEX');
            return result.values;
        }
        return Promise.resolve(EXECUTION_LIST_DROPDOWN_OPTIONS[searchKey] || []);
    }
}

export const DYNAMIC_DROPDOWN_FIELDS = [
    programColumnMetadata.key,
    targetedWebsiteColumnMetadata.key,
    subProgramColumnMetadata.key,
    workflowStatusColumnMetadata.key
];